// Configuration › Booking Hotel Priority: grouping of the ranked hotels per airport and crew type, and list moves.

export const MENU_CODE = "booking-hotel-priority";

export const CREW_TYPES = [
  { code: "P", label: "Cockpit", icon: "fas fa-plane" },
  { code: "F", label: "Cabin crew", icon: "fas fa-user-friends" },
];

export const STATUS_FILTERS = [
  { id: "set", label: "With priority", icon: "fas fa-sort-amount-down", tone: "success" },
  { id: "missing", label: "Without priority", icon: "fas fa-exclamation-circle", tone: "muted" },
  { id: "all", label: "All airports", icon: "fas fa-plane-departure", tone: "primary" },
];

/**
 * One card per airport: { airportCode, airportName, lists: { P: rows, F: rows }, count } in airport order. Airports of the
 * dropdown without any priority come too (empty lists), as do airports with priorities missing from the dropdown.
 */
export function groupByAirport(rows, airports) {
  const cards = new Map();
  const card = (code, name) => {
    if (!cards.has(code)) cards.set(code, { airportCode: code, airportName: name || code, lists: { P: [], F: [] }, count: 0 });
    return cards.get(code);
  };
  airports.forEach((a) => card(a.airportCode, a.airportName));
  rows.forEach((r) => {
    const c = card(r.airportCode, "");
    if (!c.lists[r.crewType]) c.lists[r.crewType] = [];
    c.lists[r.crewType].push(r);
    c.count += 1;
  });
  cards.forEach((c) => Object.values(c.lists).forEach((list) => list.sort((a, b) => a.priority - b.priority)));
  return [...cards.values()].sort((a, b) => a.airportCode.localeCompare(b.airportCode));
}

/** Cards of a filter tab: "set" (at least one hotel), "missing" (none), "all". */
export const filterCards = (cards, status) => (status === "all" ? cards : cards.filter((c) => (status === "set" ? c.count > 0 : c.count === 0)));

/** A copy of the list with the item at index moved by delta (-1 up, +1 down); the same list when it cannot move. */
export function moveItem(list, index, delta) {
  const to = index + delta;
  if (to < 0 || to >= list.length) return list;
  const next = [...list];
  [next[index], next[to]] = [next[to], next[index]];
  return next;
}

/** True when both lists hold the same hotels in the same order. */
export const sameOrder = (a, b) => a.length === b.length && a.every((r, i) => r.hotelCode === b[i].hotelCode);

/** Crew types (codes) whose list already has the hotel option. */
export const listedFor = (option) =>
  String(option?.listedFor ?? "")
    .split(",")
    .filter(Boolean);
